import React, { FunctionComponent, useMemo } from "react";
import { Theme, makeStyles, AccordionSummary, Typography, Grid, useTheme } from "@material-ui/core";
import { CATEGORY_MENU_FONT_SIZE } from "../../menu/category-item-menu";
import { DARK_TEXT_COLOR } from "../../../theme/theme";
import { ArrowRightIcon } from "../../../assets/icons/arrows/arrow-right-icon";
import { IIconProps } from "../../../assets/icons/icon";

const ICON_SIZE = 25;

interface ITopBarAccordionHeaderStyleProps {
  active: boolean;
  open: boolean;
  isButton: boolean;
  fontColor?: string;
  textWeight?: number;
  textSize?: number;
}

const useStyles = makeStyles((theme: Theme) => ({
  titleContainer: {
    marginLeft: theme.spacing(2),
  },
  title: {
    fontSize: ({ textSize }: ITopBarAccordionHeaderStyleProps) => (textSize ? textSize : 17),
    fontWeight: ({ textWeight }: ITopBarAccordionHeaderStyleProps) => (textWeight ? textWeight : 400),
    color: ({ fontColor }: ITopBarAccordionHeaderStyleProps) => fontColor,
    marginLeft: theme.spacing(4),
  },
  accordionSummaryExpanded: {
    margin: "auto !important",
    minHeight: "48px !important",
  },
  arrow: {
    marginRight: theme.spacing(6),
    transition: "all 0.2s linear",
    transform: ({ open, isButton }: ITopBarAccordionHeaderStyleProps) =>
      isButton ? "" : !open ? "rotate(90deg)" : "rotate(-90deg)",
  },
}));

interface ITopBarAccordionHeaderProps {
  Icon?: FunctionComponent<IIconProps>;
  active: boolean;
  open: boolean;
  onClick?: () => void;
  className?: string;
  textColor?: string;
  textWeight?: number;
  textSize?: number;
  iconSize?: number;
}

export const TopBarAccordionHeader: FunctionComponent<ITopBarAccordionHeaderProps> = (props) => {
  const { Icon, active, open, onClick, children, className, textColor, textWeight, textSize, iconSize } = props;
  const theme = useTheme();
  const isButton = useMemo(() => !!onClick, [onClick]);

  const fontColor = useMemo(
    () => (textColor ? textColor : open || active ? theme.palette.primary.main : DARK_TEXT_COLOR),
    [textColor, open, active, theme],
  );
  const classes = useStyles({ active, open, isButton, fontColor, textWeight, textSize });

  return (
    <AccordionSummary
      classes={{ expanded: classes.accordionSummaryExpanded, content: classes.accordionSummaryExpanded }}
    >
      <Grid container justify="space-between" alignItems={"center"} onClick={onClick} className={className}>
        <Grid item xs>
          <Grid container alignItems="center" className={classes.titleContainer}>
            {Icon && (
              <Icon
                height={iconSize ? iconSize : ICON_SIZE}
                width={iconSize ? iconSize : ICON_SIZE}
                color={fontColor}
              />
            )}
            <Typography className={classes.title}>{children}</Typography>
          </Grid>
        </Grid>
        <Grid item>
          <Typography className={classes.arrow}>
            <ArrowRightIcon width={CATEGORY_MENU_FONT_SIZE - 3} color={fontColor} />
          </Typography>
        </Grid>
      </Grid>
    </AccordionSummary>
  );
};
